module.exports = __webpack_public_path__ + "img/emojione_cherry-blossom.cd1e0ac1.svg";